import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownSmallLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.46452 10.2928C8.85505 9.90232 9.48821 9.90232 9.87874 10.2928L12.0001 12.4142L14.1214 10.2928C14.5119 9.90232 15.1451 9.90232 15.5356 10.2928C15.9261 10.6834 15.9261 11.3165 15.5356 11.707L12.7072 14.5355C12.3166 14.926 11.6835 14.926 11.293 14.5355L8.46452 11.707C8.074 11.3165 8.074 10.6834 8.46452 10.2928Z"
	})
});
export default SvgDownSmallLine;
